// Boot-guard decision logic — the canonical, unit-tested version (boot_guard.test.mjs).
//
// The actual guard runs from an inline <script> in layouts/_boot_guard.html.erb: it must
// be a synchronous, non-module script so its capture-phase listener is installed before
// the body is parsed and before any deferred module (jquery-ujs, Stimulus) evaluates.
// That means it cannot `import` this file, so it inlines an equivalent copy of SELECTOR
// and the swallow decision. Keep the two in sync — THIS module is the source of truth.

export const BOOT_GUARD_SELECTOR =
  '[data-action],[data-method],[data-remote],[data-trigger-modal]'

// Should this click be swallowed now and replayed once the page's JS is ready?
// Only a plain left-click (no modifier keys) on a JS-dependent control, and only while
// the page hasn't finished booting. Modifier/middle clicks (open-in-new-tab etc.) and
// clicks on plain links/buttons are left to their native behavior.
export function shouldSwallowClick({
  ready,
  button,
  metaKey,
  ctrlKey,
  shiftKey,
  altKey,
  matchesSelector,
}) {
  if (ready) return false
  if (button !== 0) return false
  if (metaKey || ctrlKey || shiftKey || altKey) return false
  return Boolean(matchesSelector)
}

// Confirmation must happen on the user's original click. Deferring it until replay makes
// a control look dead while the rest of the page boots. Controls without data-confirm can
// be queued directly; canceled controls must not be replayed.
export function confirmBeforeReplay(message, confirm) {
  return !message || confirm(message)
}

export function replayClick(element, confirmedMessage) {
  if (confirmedMessage) element.removeAttribute('data-confirm')
  try {
    element.click()
  } finally {
    if (confirmedMessage) element.setAttribute('data-confirm', confirmedMessage)
  }
}
